<template>
  <div class="page dashboard order-dashboard">
    <div class="content">
      <div class="title-bar">
        <p class="title">Claim Voucher History</p>
      </div>
      <!-- <TabBarComponent
        :isLoading="false"
        :query.sync="query"
        :data="status"
        queryKey="status"
        :label="(r) => r.label"
        :key="false"
        :hasAll="false"
      /> -->
      <input
        placeholder="Search for ..."
        type="text"
        class="search"
        v-model="query.search"
      />
      <input
        type="date"
        class="search"
        style="margin-left: 10px; margin-bottom: 10px; width: 20%"
        v-model="query.fromDate"
      />
      <input
        type="date"
        class="search"
        style="margin-left: 10px; margin-bottom: 10px; width: 20%"
        v-model="query.toDate"
      />
      <ListingComponent
        model="data"
        :isLoading="isLoadingItem"
        :data="items"
        :query.sync="query"
        :refresh="getItems"
        :listingOptions="listingOptions"
        :deleteRecord="() => {}"
      />
      <div :class="`action-menu ${isActionMenuOpen ? 'active' : ''}`">
      <div class="btn close" v-on:click="toggleActionMenu('')"></div>
        <UpdateStatus
          v-if="isActionMenuOpen === 'read'"
          :request="focusedRequest"
          :toggleActionMenu="toggleActionMenu"
          :getRequest="getRequest"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ListingLoadingComponent from "../../components/ListingLoadingComponent";
import ListingComponent from "../../components/ListingComponent";
import TabBarComponent from "../../components/TabBarComponent";
import moment from "moment";
import { API_URL } from "../../const";
import UpdateStatus from "./UpdateStatus"
export default {
  name: "VoucherDashboard",
  components: {
    ListingLoadingComponent,
    ListingComponent,
    TabBarComponent,
    UpdateStatus
  },
  data() {
    return {
      isActionMenuOpen: "",
      isLoadingItem: false,
      searchTimeout: null,
      focusedRequest: {},
      query: {
        order: "ASC",
        page: 1,
        limit: 10,
        sortBy: "createdAt",
        status: 0,
        fromDate: null,
        toDate: null,
      },
      status: [
        { _id: -1, label: "All" },
        { _id: 0, label: "Pending" },
        { _id: 1, label: "Confirmed" },
        { _id: 2, label: "Rejected" },
      ],
    };
  },
  created() {
    this.getItems();
  },
  methods: {
    async getItems(keyword) {
      this.isLoadingItem = true;
      await this.$store.dispatch(
        "voucherHistoryModule/getVoucherHistory",
        this.query
      );
      this.isLoadingItem = false;
    },

    getStatus(status) {
      switch (status) {
        // case -1: 
        //   return "All"
        case 0:
          return "Pending";
        case 1:
          return "Confirmed";
        case 2:
          return "Rejected";
      }
    },
  },
  watch: {
    query: {
      deep: true,
      handler: function () {
        if (this.query.page >= 1) {
          this.getItems();
        }
      },
      search: function () {
        this.searchTimeout && clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => this.getItems(), 500);
      },
    },
  },
  computed: {
    items() {
      return this.$store.state.voucherHistoryModule.voucherHistory;
    },
    listingOptions() {
      return {
        hasSelected: false,
        hasNo: true,
        actions: [],
        queryOptions: {
          sortBy: [{ label: "CreatedAt", value: "createdAt" }],
          sortDirection: [
            { label: "Ascending", value: "ASC" },
            { label: "Descending", value: "DESC" },
          ],
        },
        schema: [
          {
            label: "Username",
            key: "user",
            value: (r) => r.user?.name,
          },
          {
            label: "Code",
            key: "voucher_code",
            value: (r) => r.voucher?.code,
          },
          {
            label: "Top Up Balance",
            key: "top_up_balance",
            value: (r) => r.voucher?.top_up_balance,
          },
          {
            label: "Voucher Balance",
            key: "voucher",
            value: (r) => r.voucher?.balance,
          },
          // {
          //   label: "Status",
          //   key: "status",
          //   value: (r) => this.getStatus(r.status),
          // },
          {
            label: "Created At",
            key: "createdAt",
            value: (r) => moment(r.createdAt).format("YYYY-MM-DD HH:mm"),
          }
        ],
      };
    },
  },
  API_URL() {
    return API_URL;
  },
};
</script>